module.exports = __webpack_public_path__ + "img/ar_inter_pink.03779c08.svg";